module.exports = __webpack_public_path__ + "static/skybox-4be6273a0e85119731726eb9a21ae13e.png";